<template>
  <div class="content-430">
    <div class="class-form-head">课时信息</div>
    <div class="class-form-content">
      <Form
        ref="classHourInfo"
        :model="classHourInfo"
        label-position="right"
        :label-width="120"
        :rules="classHourInfoRule"
        @on-validate="getFormValidate"
      >
        <FormItem label="累计课时" prop="classroomTotal" class="tip-erro">
          <Input
            v-model="classHourInfo.classroomTotal"
            :disabled="exsitOrder"
            class="w-40"
            placeholder="请填写"
            @on-blur="handleTrimValue('classroomTotal')"
          ></Input>
          <span class="ml-2">节</span>
          <div class="tip">
            家长报名付费的总课时，请输入≥1的整数，<span class="font-red">商品被购买后无法修改</span>
          </div>
        </FormItem>

        <FormItem label="单节时长" prop="classTime" class="tip-erro">
          <Input
            v-model="classHourInfo.classTime"
            placeholder="请填写"
            class="w-40"
          ></Input>
          <span class="ml-2">分钟</span>
          <div class="tip">
            单节课程的时长，请输入≥0的整数，<span class="font-red">仅用于商品信息展示</span>，实际以分班后上课时间为准
          </div>
        </FormItem>
        <FormItem
          label="课程显示价格"
          prop="courseDisplayPriceShow"
          class="tip-erro"
        >
          <Input
            v-model="classHourInfo.courseDisplayPriceShow"
            :disabled="exsitOrder"
            placeholder="请填写"
            class="w-40"
            @on-blur="getTrueShowFee"
          ></Input>
          <span class="ml-2">元</span>
          <div class="tip">
            课程商品显示价格，非实际购买，用于家长端显示，价格需≥0，支持到小数点后两位，<span
              class="font-red"
            >商品被购买后无法修改</span>
          </div>
        </FormItem>

        <FormItem label="课程价格" prop="feeShow" class="tip-erro">
          <Input
            v-model="classHourInfo.feeShow"
            :disabled="exsitOrder"
            placeholder="请填写"
            class="w-40"
            @on-blur="getTrueFee"
          ></Input>
          <span class="ml-2">元</span>
          <div class="tip">
            课程商品总价格，价格需≥0，支持到小数点后两位，<span class="font-red">商品被购买后无法修改</span>
          </div>
        </FormItem>

        <FormItem label="预计开课日期" class="tip-erro">
          <div class="date-line">
            <DatePicker
              v-model="begin"
              :options="beginDateOption"
              type="date"
              placeholder="选择开始日期"
              @on-change="getThisDate($event, 'classDateBegin')"
            ></DatePicker>
            <span>至</span>
            <DatePicker
              v-model="end"
              :options="endDateOption"
              type="date"
              placeholder="选择结束日期"
              @on-change="getThisDate($event, 'classDateEnd')"
            ></DatePicker>
          </div>
          <div class="tip">
            课程的开始结束日期，<span class="font-red">仅用于商品信息展示</span>，实际以分班后开课时间为准
          </div>
        </FormItem>

        <FormItem label="预计上课时间" prop="arrangingRule">
          <div class="arranging-rule">
            <RadioGroup v-model="arrangingRuleTag">
              <Radio
                v-for="(item, index) in classTimeSetting"
                :key="index"
                :disabled="classroomId && !isCopy ? true : false"
                :label="item.value"
              >{{ item.label }}</Radio>
            </RadioGroup>
            <div class="time-change-block">
              <CheckboxGroup v-model="schoolTimeWeekDateList">
                <Checkbox
                  v-for="(item, index) in schoolTimeListShow"
                  :key="index"
                  :label="item.weekDate"
                >{{ item.weekName }}</Checkbox>
              </CheckboxGroup>
              <div v-for="(item,index) in classTimeSelectList" :key="index" class="time-select">
                <div class="time-line">
                  <TimePicker
                    v-model="classTimeSelectList[index]"
                    style="margin-right: 10px;"
                    :steps="[1, 5]"
                    :disabled-hours="[0, 1, 2, 3, 4, 5, 23, 24]"
                    hide-disabled-options
                    format="HH:mm"
                    type="timerange"
                    placement="bottom-end"
                    placeholder="请选择上课起止时间"
                    @on-open-change="onTimeOpenChange"
                  ></TimePicker>
                  <Icon style="margin-right: 10px;" size="24" color="#2d8cf0" type="md-add-circle" @click="handleAddClassTime(index)"></Icon>
                  <Icon v-if="classTimeSelectList.length!==1" size="24" color="#ed4014" type="md-remove-circle" @click="handleDelClassTime(index)"></Icon>
                </div>
              </div>
            </div>
            <div style="tip">
              课程的上课时间，<span class="font-red">仅用于商品信息展示</span>，实际以分班后上课时间为准，例：周一至周五 15:30-16:30
            </div>
            <div class="color-gray">
              <div>
                <RadioGroup v-model="classHourInfo.isHideClasstime">
                  <Radio label="0">显示课程开始时间</Radio>
                  <Radio label="1">隐藏课程开始时间</Radio>
                </RadioGroup>
              </div>
              <div>
                <RadioGroup v-model="classHourInfo.isHideClasstimeTail">
                  <Radio label="0">显示课程结束时间</Radio>
                  <Radio label="1">隐藏课程结束时间</Radio>
                </RadioGroup>
              </div>
            </div>
            <p>隐藏后，家长端选课时，看不到课程的起止时间</p>
          </div>
        </FormItem>
        <FormItem label="推荐报名年级">
          <Select v-model="classHourInfo.gradeMin" class="w-40">
            <Option
              v-for="item in likeGradesList"
              :key="item.value"
              :value="item.value"
            >{{ item.label }}</Option>
          </Select>
          ~
          <Select v-model="classHourInfo.gradeMax" class="w-40">
            <Option
              v-for="item in likeGradesList"
              :key="item.value"
              :value="item.value"
            >{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="授课教师">
          <ChooseTeacherForForm
            :school-id="schoolId"
            :apply-id="orgId"
            :is-couser="true"
            :parent-teacher-list="teacherList"
            @postTeacherData="getSelectTeacherData"
          ></ChooseTeacherForForm>
        </FormItem>
        <FormItem label="需要教室数" prop="reqRoomCount">
          <Input v-model="classHourInfo.reqRoomCount" class="w-40"></Input>
          <!-- <InputNumber
            v-model="classHourInfo.reqRoomCount"
            :min="0"
          ></InputNumber> -->
        </FormItem>
      </Form>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import ChooseTeacherForForm from '@c/searchBlock/ChooseTeacherForForm';
import { weekList, gradeList } from '@/utils/dictionary.js';
import { formatTime, checkTimeRangehasIntersection } from '@/utils/utils';

export default {
  components: {
    ChooseTeacherForForm
  },
  inject: ['AddCommodityInstance'],
  props: {
    isCopy: {
      type: Boolean,
      default: false
    },
    exsitOrder: {
      type: Boolean,
      default: false
    }, // 商品是否已被购买，是否存在订单
    orgId: {
      type: String,
      default: ''
    },
    schoolId: {
      type: String,
      default: ''
    },
    classroomId: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: () => {
        return {
          'classroomTotal': '', // 累计课时
          'classTime': '', // 单节时长
          'courseDisplayPriceShow': '',
          'courseDisplayPrice': '',
          'feeShow': '', // 课程价格
          'fee': '', // 费用(feeShow*100)
          'classDateBegin': '', // 预计开课开始时间
          'classDateEnd': '', // 预计开课结束时间
          // 'arrangingRule': '', // 是否填完了预计上课时间这一栏
          'arrangingRuleBo': {
            // 'schoolTimeList': [ // 上课时间
            //   {
            //     'weekDate': 0,
            //     'classTimeBegin': '2022-04-24 20:43:19',
            //     'classTimeEnd': '2022-04-24 20:43:19'
            //   }
            // ],
            // 'ruleType': 0 // 估计类型, 1-周循环 2-指定上课周
          }, // (courseClassExtAddRO)
          'gradeMin': 1, // 推荐最小年级：小学初中高中分别对应1-12，幼儿园小中大班分别为13-15
          'gradeMax': 12, // 推荐最大年级：小学初中高中分别对应1-12，幼儿园小中大班分别为13-15
          'teacherIds': [], // 授课教师
          'reqRoomCount': '', // 需求教室数 (courseClassExtAddRO)
          'isHideClasstime': '0', // 是否显示课程开始时间 1:隐藏 0：显示  (courseClassExtAddRO)
          'isHideClasstimeTail': '0' // 是否显示课程结束时间 1:隐藏 0：显示  (courseClassExtAddRO)

        };
      }
    }, // v-model的值
    validatePass: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validateClassroomTotal = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入课时'));
      } else if (!Number.isInteger(+value) || value < 1) {
        callback(new Error('请输入大于或等于1的整数'));
      } else {
        callback();
      }
    };
    // 单节时长校验
    const validateClassMinuts = (rule, value, callback) => {
      if (!Number.isInteger(+value) || value < 0) {
        callback(new Error('请输入大于或等于0的整数'));
      } else {
        callback();
      }
    };
    // 课程价格规则
    const validateCoursePrice = (rule, value, callback) => {
      let length = 0;
      const arr = value.split('.');
      if (arr.length === 2) {
        length = arr[1].length;
      }
      if (value === '') {
        callback(new Error('请输入价格'));
      } else if (Number.parseFloat(value) < 0) {
        callback(new Error('请输入大于或等于0的金额'));
      } else if (length > 2) {
        callback(new Error('请输入最多两位小数的金额'));
      } else if (arr.length > 2) {
        callback(new Error('请输入一个小数点'));
      } else {
        callback();
      }
    };
    // 课程价格规则
    const validateCourseDisplayPrice = (rule, value, callback) => {
      let length = 0;
      const arr = value.split('.');
      if (arr.length === 2) {
        length = arr[1].length;
      }
      if (value === '') {
        callback();
      } else if (Number.parseFloat(value) < 0) {
        callback(new Error('请输入大于或等于0的金额'));
      } else if (length > 2) {
        callback(new Error('请输入最多两位小数的金额'));
      } else if (arr.length > 2) {
        callback(new Error('请输入一个小数点'));
      } else {
        callback();
      }
    };
    const validateArrangingRule = (rule, value, callback) => {
      if (this.schoolTimeWeekDateList.length === 0) {
        this.classHourInfo.arrangingRule = '';
        callback(new Error('请先选择每周要上课的日期！'));
      } else {
        let tag = this.classTimeSelectList.some(item => {
          return item.length !== 2 || (item.length === 2 && (!item[0] || !item[1]));
        });
        tag ? callback(new Error('起止时间（必填不可为空）')) : '';
        if (tag) {
          return;
        }
        const copyData = [...this.classTimeSelectList];
        for (let i = 0; i < this.classTimeSelectList.length; i++) {
          const originItem = copyData.splice(0, 1)[0];
          for (let x = 0; x < copyData.length; x++) {
            const compareItem = copyData[x];
            tag = checkTimeRangehasIntersection(originItem, compareItem);
            if (tag) {
              callback(new Error(`第${i + 1}行 与 第${i + 1 + x + 1}行 的起止时间存在交叉！`));
              break;
            }
          }
          if (tag) {
            break;
          }
        }
        if (!tag) {
          this.classHourInfo.arrangingRule = 'has';
          this.fillArrangingRuleBo();
          callback();
        }
      }
    };
    return {
      classHourInfoRule: {
        classroomTotal: [
          { required: true, validator: validateClassroomTotal, trigger: 'blur' }
        ],
        classTime: [{ validator: validateClassMinuts, trigger: 'blur' }],
        feeShow: [{ required: true, validator: validateCoursePrice, trigger: 'change' }],
        courseDisplayPriceShow: [{ validator: validateCourseDisplayPrice, trigger: 'change' }],
        arrangingRule: [{ required: true, validator: validateArrangingRule, trigger: 'change,blur' }],
        reqRoomCount: [{ validator: validateClassMinuts, trigger: 'blur' }]
      },
      arrangingRuleTag: 1, // 现在的数据都只有1，只有每天上课时间相同  1:每天上课时间相同 2:每天上课时间不同
      schoolTimeWeekDateList: [],
      schoolTimeListShow: [], // 展示的
      weekList: [...weekList],
      begin: null,
      end: null,
      classTimeSetting: [
        {
          label: '每天上课时间相同',
          value: 1
        }
      ],
      likeGradesList: gradeList,
      teacherList: [], // 选择的教师
      classHourInfoRequired: {},
      classTimeSelectList: [[]]// 每天上课时间相同选择的上课时间段

    };
  },
  computed: {
    ...mapState(['userInfo']),
    // 开始日期应该不能小于结束日期
    beginDateOption() {
      const that = this;
      return {
        disabledDate(date) {
          let status = true;
          // 如果有结束日期的话
          if (that.end) {
            status = date && date.valueOf() < that.end.valueOf() + 86400000;
          }
          return !status;
        }
      };
    },
    // 开始日期应该不能小于结束日期
    endDateOption() {
      const that = this;
      return {
        disabledDate(date) {
          let status = true;
          // 如果有结束日期的话
          if (that.begin) {
            status = date && date.valueOf() > that.begin.valueOf() - 86400000;
          }
          return !status;
        }
      };
    },
    classHourInfo: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    } // 课程信息
  },
  // watch: {
  //   classHourInfo: {
  //     handler(newVal, oldVal) {
  //       // this.AddCommodityInstance.findRuleRequireNewCourse(this, 'classHourInfo', '课时信息');
  //     },
  //     deep: true
  //   }
  // },
  created() {
    this.initClassTimeList();
    this.dealFormRequire();
  },
  mounted() {
    this.AddCommodityInstance.findRuleRequireNewCourse(this, 'classHourInfo', '课时信息');
  },
  methods: {
    handleAddClassTime(index) {
      if (this.classTimeSelectList.length === 5) {
        this.$Message.error('最多支持5个时间段');
        return;
      }
      const time = this.classTimeSelectList[index];
      let timeSelect = [];
      if (time && time.length === 2) {
        timeSelect = [time[1], time[1]];
      }
      this.classTimeSelectList.splice(index + 1, 0, timeSelect);
    },
    handleDelClassTime(index) {
      this.classTimeSelectList.splice(index, 1);
      this.$refs.classHourInfo.validateField('arrangingRule');
    },
    //
    onTimeOpenChange(status) {
      if (status) {
        setTimeout(() => {
          const dom = document.querySelectorAll('.ivu-time-picker-cells-list');
          for (let i = 0, len = dom.length; i < len; i++) {
            dom[i].scrollTop = 0;
          }
        }, 300);
      }
    },
    getFormValidate(prop, status, error) {
      this.classHourInfoRequired[prop].status = status;
      this.AddCommodityInstance.findRuleRequireNewCourse(this, 'classHourInfo', '课时信息');
    },
    dealFormRequire() {
      Object.keys(this.classHourInfoRule).forEach(item => {
        this.classHourInfoRequired[item] = {
          require: !!this.classHourInfoRule[item][0].required,
          status: false
        };
      });
    },
    // 回显上课时间
    fillTimeList() {
      // 每周上课的日期
      const list = this.classHourInfo.arrangingRuleBo.schoolTimeList.map(item => {
        return item.weekDate;
      });
      this.schoolTimeWeekDateList = [...new Set(list)];
      const weekDate = this.schoolTimeWeekDateList[0];
      const timeList = this.classHourInfo.arrangingRuleBo.schoolTimeList.filter(item => {
        return item.weekDate === weekDate;
      });
      this.classTimeSelectList = [];
      timeList.forEach(item => {
        this.classTimeSelectList.push([item.classTimeBegin.split(' ')[1], item.classTimeEnd.split(' ')[1]]);
      });
      this.classTimeSelectList.length === 0 ? this.classTimeSelectList = [[]] : '';
      this.classHourInfo.arrangingRule = 'has';
    },
    // 根据输入的课程价格得出提交表单需要的课程价格
    getTrueFee() {
      if (this.classHourInfo.feeShow) {
        this.classHourInfo.fee = this.classHourInfo.feeShow;
      } else {
        this.classHourInfo.fee = '';
      }
    },
    getTrueShowFee() {
      if (this.classHourInfo.courseDisplayPriceShow) {
        this.classHourInfo.courseDisplayPrice = this.classHourInfo.courseDisplayPriceShow;
      } else {
        this.classHourInfo.courseDisplayPrice = '';
      }
    },
    // 校验表单
    checkForm() {
      this.$refs.classHourInfo.validate();
    },
    // 校验数组里面是否存在空字符的项
    checkIsEmpty(arr) {
      if (arr.length === 0) {
        return true;
      }
      return arr.some(item => {
        return item === '';
      });
    },
    handleTrimValue(keyName) {
      if (!keyName) {
        return null;
      }
      this.classHourInfo[keyName] = this.classHourInfo[keyName].trim();
    },
    // 生成classTimeList列表
    initClassTimeList() {
      this.schoolTimeListShow = this.weekList.map(item => {
        const obj = {
          weekDate: item.value,
          weekName: item.label
        };
        return obj;
      });
    },
    // 打开弹窗
    openModal(name, id) {
      this.$refs[name].open(id);
    },
    // 关闭弹窗
    closeModal(name) {
      this.$refs[name].close();
    },
    getThisDate(date, name) {
      if (date) {
        this.classHourInfo[name] = name === 'classDateBegin' || name === 'classDateStart' ? `${date} 00:00:00` : `${date} 23:59:59`;
      } else {
        this.classHourInfo[name] = null;
      }
    },
    // 授课教师
    getSelectTeacherData(teacherData) {
      this.classHourInfo.teacherIds = teacherData.map(item => item.userId);
    },
    fillArrangingRuleBo() {
      const schoolTimeList = [];
      const date = formatTime(new Date());
      this.schoolTimeWeekDateList.forEach(item => {
        this.classTimeSelectList.forEach(x => {
          const obj = {
            weekDate: item,
            classTimeBegin: `${date} ${x[0]}:00`,
            classTimeEnd: `${date} ${x[1]}:00`
          };
          schoolTimeList.push(obj);
        });
      });
      this.classHourInfo.arrangingRuleBo = {
        classesTimeType: 1,
        ruleType: 1, // 估计类型, 1-周循环 2-指定上课周
        schoolTimeList
      };
      console.log(this.schoolTimeWeekDateList, this.classTimeSelectList, schoolTimeList, '拿到的上课时间---------');
    }

  }

};
</script>
<style lang="scss" scoped>
.date-line {
  display: flex;
  align-items: center;
  span {
    margin: 0 8px;
  }
}
.arranging-rule {
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 80%;
  padding: 10px 12px;
}
.time-change-block {
  width: 500px;
  // padding: 16px 0;
  // background: rgba(0,0,0,0.03);
  // border-radius: 4px;
  // margin-top: 8px;
  .time-select {
    margin-top: 16px;
    .time-line{
      display: flex;
      align-items: center;
    }
  }
  .time-change-item + .time-change-item {
    margin-top: 16px;
  }
  .time-change-item {
    .time-block {
      margin-left: 8px;
    }
  }
  .week-line {
    margin-bottom: 8px;
  }
  .week-del-btn {
    color: rgb(255, 68, 68);
    margin-left: 16px;
  }
  .week-add-btn {
    color: #488ffa;
  }
  .week-tips {
    // margin-left: 16px;
    color: #999;
    font-size: 12px;
  }
}
</style>
